import { HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { NotifyService } from '@services/core-services/notify.service';
import { Observable, of, Subject, throwError } from 'rxjs';

export interface ErrorHandlerConfig {
  notify?: boolean;
  message?: string;
}

@Injectable({ providedIn: 'root' })
export class ErrorHandlerService {
  errorOccurred = new Subject<string>();

  constructor(private readonly notifyService: NotifyService) {}

  private getErrorMessage(status: number): { title: string; message: string } {
    switch (status) {
      case 400:
        return {
          title: 'Oops! Something went wrong with your request.',
          message: 'Please check the information you provided and try again.',
        };
      case 401:
        return {
          title: 'You need to be logged in to access this resource.',
          message: 'Please log in and try again.',
        };
      case 403:
        return {
          title: 'Access Denied.',
          message: 'It looks like you don’t have permission to view this resource.',
        };
      case 404:
        return {
          title: 'We couldn’t find what you’re looking for.',
          message: 'The resource you requested might have been moved or deleted.',
        };
      case 429:
        return {
          title: 'Too Many Requests.',
          message:
            'You’ve made too many requests in a short period. Please slow down and try again later.',
        };
      case 500:
        return {
          title: 'Our apologies! Something went wrong on our end.',
          message: 'Please try again in a few moments.',
        };
      case 502:
        return {
          title: 'Our apologies! Something went wrong on our end.',
          message: 'Please try again in a few moments.',
        };
      default:
        return {
          title: `Error ${status}: Something unexpected happened.`,
          message: 'Please refresh the page or try again later.',
        };
    }
  }

  handle(err: any, config?: ErrorHandlerConfig): Observable<any> {
    // TODO: Wire with real logger
    const { notify, message } = config || {};
    if (notify) {
      this.notifyService.error(message || '');
    }

    return throwError(() => err);
  }

  handleAndNotify(err: any, message: string, config?: ErrorHandlerConfig): Observable<any> {
    return this.handle(err, { ...(config || {}), message, notify: true });
  }
  handleServerError(error: HttpErrorResponse): { title: string; message: string } {
    const errorMessage = this.getErrorMessage(error.status);
    console.error('Error message:', errorMessage);
    this.errorOccurred.next(errorMessage.message);
    return errorMessage;
  }
}
